/**
 * Configure $locationProvider
 */
angular.module('ffApp').config(['$locationProvider', function($locationProvider)
{
	if ( window.history && history.pushState )
	{
		$locationProvider.html5Mode({
			enabled: true,
			requireBase: true,
			rewriteLinks: false
		});
	}
}]);

/**
 * Head controller
 */
angular.module('ffApp').controller('HeadController', ['$scope', '$rootScope', '$sce', function($scope, $rootScope, $sce)
{
	$rootScope.pageTitle = window.pageTitle;

	/**
	 * Return page title
	 * @returns {*}
	 */
	$scope.getPageTitle = function()
	{
		return $sce.trustAsHtml($rootScope.pageTitle);
	};
}]);

/**
 * Content controller
 */
angular.module('ffApp').controller('ContentController', ['$scope', '$rootScope', '$resource', '$sce', '$http', '$location', '$timeout', function($scope,
																		 $rootScope,
																		 $resource,
																		 $sce,
																		 $http,
																		 $location,
																		 $timeout)
{
	$scope.content = '';

	/**
	 * Check if URL should be ajaxloaded or not
	 *
	 * @param url
	 * @returns {boolean}
	 */
	function shouldThisUrlBeAjaxLoaded(url)
	{
		return ( url.indexOf(homeUrl) > -1 && url.indexOf(homeUrl + '/wp/') === -1 && url.indexOf(homeUrl + '/logout/') === -1 );
	}

	// Browser that does not support pushState will have to load the pages as usual
	if ( window.history && history.pushState )
	{
		$('body').on('click', 'a', function(e)
		{
			var url = $(this).attr('href');

			// Only do this for "local" URLs
			if ( typeof url != 'undefined' && url.length > 0 && shouldThisUrlBeAjaxLoaded(url) )
			{
				// Remove home URL part of URL
				url = url.replace(homeUrl, '');

				// Update location
				$location.path(url);

				if ( !$scope.$$phase )
				{
					$scope.$apply();
				}

				e.preventDefault();
				e.stopPropagation();
				return false;
			}
		});
	}
	$rootScope.$on('$locationChangeSuccess', function(event, newUrl, oldUrl)
	{

	});

	jQuery(window).on('ngPageLoadSuccess', function(){
		//console.log('scrolling...');
		jQuery("html, body").animate({ scrollTop: "0px", easing: 'easeOutQuint' });
	});

    $rootScope.$on('$locationChangeStart', function(event, next, current)
    {
    		next = next.replace( '%3F', '?' );

		if ( next != current && shouldThisUrlBeAjaxLoaded(next) )
		{
			// Add 'ng' query var to URL

			if ( next.indexOf('?') > -1 || next.indexOf('?%3F') > -1 )
			{
				next = next + '&ng=1';
			}
			else
			{
				next = next + '?ng=1';
			}

			//Signal page navigation to child controllers
			jQuery(window).trigger('ngBeforePageLoad');

			//Suspend page with loader
			jQuery('body').addClass('loading');

			// Load content from this URL
			$http({
				method: 'GET',
				url: next
			})
			.then(function(response)
			{
				var headers = response.headers;

				$scope.content = response.data;

				FB.XFBML.parse();
				
				var pageTitle = headers('x-page-title');

				jQuery(window).trigger('ngPageLoadSuccess', { pageTitle: pageTitle });

				$rootScope.pageTitle = pageTitle;

				jQuery('body').removeClass('loading');

				$timeout(function(){
					if( typeof FB != 'undefined' && FB.hasOwnProperty('XFBML') && typeof FB.XFBML.parse == 'function' )
					{
						FB.XFBML.parse(); //Again!
					}
					if( typeof twttr != 'undefined' && twttr.hasOwnProperty('widgets') && typeof twttr.widgets.load == 'function' )
					{
						twttr.widgets.load();
					}
				}, 500);

			}, function(response)
			{
				jQuery('body').removeClass('loading');
			});
		}
    });
}]);

/**
 * Our related content rendering directive
 */
angular.module('ffApp').directive('renderContent', ['$compile', '$sce', function($compile, $sce)
{
	var init = true;
	return function(scope, element, attrs)
	{
        scope.$watch(attrs.renderContent, function(newValue)
		{
			if ( init != true )
			{
				element.html($compile(newValue)(scope));
			}

			init = false;
		});
	};
}]);